export const ROLE_USER = 'ROLE_USER';
export const ROLE_ADMIN = 'ROLE_ADMIN';
export const ROLE_ANALYST = 'ROLE_ANALYST';
export const ROLE_ANALYST_ADMIN = 'ROLE_ANALYST_ADMIN';
export const ROLE_EMPLOYEE = 'ROLE_EMPLOYEE';
export const ROLE_TASK_OWNER = 'ROLE_TASK_OWNER';
export const ROLE_THIRD_PARTY = 'ROLE_THIRD_PARTY';
export const ROLE_PARTNER = 'ROLE_PARTNER';
